module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-25.f896a2a8.svg";